import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'smart-manage-thing-process',
  templateUrl: './manage-thing-process.component.html',
  styleUrls: ['./manage-thing-process.component.scss','../../platform-color/platform-color.css']
})
export class ManageThingProcessComponent implements OnInit {
  @Input() id = "manage-thing-process";
  constructor() { }

  ngOnInit(): void {
  }

}
